if (!customElements.get('td-material-panel')) {
  class TdMaterialPanel extends HTMLElement {
    constructor() {
      super();
      this.openDrawer = this.openDrawer.bind(this);
      this.closeDrawer = this.closeDrawer.bind(this);
      this.handleEscape = this.handleEscape.bind(this);
      this.handleCaratPrev = this.handleCaratPrev.bind(this);
      this.handleCaratNext = this.handleCaratNext.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.mainSwiper = null;
      this.thumbsSwiper = null;
      this._resizeTimer = null;
    }

    connectedCallback() {
      this.drawer = this.querySelector('.td-swatch-drawer');
      this.backdrop = this.querySelector('.td-swatch-drawer-backdrop');
      this.closeBtn = this.querySelector('.td-swatch-drawer-close');
      this.titleEl = this.querySelector('[data-swatch-drawer-title]');
      this.familyEl = this.querySelector('[data-swatch-drawer-family]');
      this.descEl = this.querySelector('[data-swatch-drawer-description]');
      this.disclaimerEl = this.querySelector('[data-swatch-drawer-disclaimer]');
      this.detailsEl = this.querySelector('[data-swatch-details]');
      this.iconsBtnEl = this.querySelector('[data-swatch-drawer-icons]');
      this.featuredSwiperEl = this.querySelector('[data-swatch-featured-area]');
      this.featuredSlidesContainerEl = this.querySelector('[data-swatch-featured-slides]');
      this.carouselEl = this.querySelector('[data-swatch-carousel]');
      this.slidesContainerEl = this.querySelector('[data-swatch-slides]');
      this.leftCaratEl = this.querySelector('[data-swatch-carat-left]');
      this.rightCaratEl = this.querySelector('[data-swatch-carat-right]');

      document.querySelectorAll('.td-material-information__swatch-image-wrapper').forEach(wrapper => {
        wrapper.addEventListener('click', this.openDrawer);
        wrapper.addEventListener('mouseenter', this.prefetchImage, { once: true });
      });

      if (this.closeBtn) this.closeBtn.addEventListener('click', this.closeDrawer);
      if (this.backdrop) this.backdrop.addEventListener('click', this.closeDrawer);
      if (this.leftCaratEl) this.leftCaratEl.addEventListener('click', this.handleCaratPrev);
      if (this.rightCaratEl) this.rightCaratEl.addEventListener('click', this.handleCaratNext);
      document.addEventListener('keydown', this.handleEscape);
      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      document.querySelectorAll('.td-material-information__swatch-image-wrapper').forEach(wrapper => {
        wrapper.removeEventListener('click', this.openDrawer);
      });
      if (this.closeBtn) this.closeBtn.removeEventListener('click', this.closeDrawer);
      if (this.backdrop) this.backdrop.removeEventListener('click', this.closeDrawer);
      if (this.leftCaratEl) this.leftCaratEl.removeEventListener('click', this.handleCaratPrev);
      if (this.rightCaratEl) this.rightCaratEl.removeEventListener('click', this.handleCaratNext);
      document.removeEventListener('keydown', this.handleEscape);
      window.removeEventListener('resize', this.handleResize);
      if (this._resizeTimer) clearTimeout(this._resizeTimer);
      this.destroySwipers();
    }

    handleResize() {
      // Debounce — coalesce rapid resize events into one update pass.
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => {
        if (this.thumbsSwiper) this.thumbsSwiper.update();
        if (this.mainSwiper) this.mainSwiper.update();
      }, 150);
    }

    handleCaratPrev() {
      if (this.thumbsSwiper) this.thumbsSwiper.slidePrev();
    }

    handleCaratNext() {
      if (this.thumbsSwiper) this.thumbsSwiper.slideNext();
    }

    prefetchImage(e) {
      const src = e.currentTarget.dataset.image;
      if (src) new Image().src = src;
    }

    openDrawer(e) {
      if (e) e.preventDefault();
      const wrapper = e.currentTarget || (e.target && e.target.closest('.td-material-information__swatch-image-wrapper'));
      if (!wrapper) return;

      const fabricTitle = wrapper.dataset.fabricTitle || '';
      const description = wrapper.dataset.description || '';
      const isLeather = wrapper.dataset.isLeather === '1';
      const bestFor = wrapper.dataset.bestFor || '';
      const content = wrapper.dataset.content || '';
      const rubCount = wrapper.dataset.rubCount || '';
      const cleaningCode = wrapper.dataset.cleaningCode || '';
      const finish = wrapper.dataset.finish || '';
      const familyName = wrapper.dataset.familyName || '';

      // Prefer linked product images (data-fabric-images) when present; otherwise fall back to data-images.
      let images = [];
      let usedFabricImages = false;
      try {
        const fabricImagesJson = wrapper.dataset.fabricImages;
        if (fabricImagesJson) {
          const fabricImages = JSON.parse(fabricImagesJson);
          if (Array.isArray(fabricImages) && fabricImages.length > 0) {
            fabricImages.forEach(item => {
              if (!item) return;
              if (typeof item === 'string') {
                images.push({ url: item, alt: fabricTitle });
              } else if (item.url) {
                images.push({ url: item.url, alt: item.alt || fabricTitle });
              }
            });
            usedFabricImages = images.length > 0;
          }
        }
      } catch (err) {
        console.error('Failed to parse fabric-images JSON:', err);
      }

      if (!usedFabricImages) {
        try {
          const imagesJson = wrapper.dataset.images;
          if (imagesJson) {
            images = JSON.parse(imagesJson);
          } else if (wrapper.dataset.image) {
            images = [{ url: wrapper.dataset.image, alt: fabricTitle }];
          }
        } catch (err) {
          console.error('Failed to parse images JSON:', err);
          if (wrapper.dataset.image) {
            images = [{ url: wrapper.dataset.image, alt: fabricTitle }];
          }
        }
      }

      // Set text fields
      if (this.titleEl) {
        this.titleEl.innerHTML = `<span>${fabricTitle}</span> / ${familyName}`.trim();
      }

      // if (this.familyEl) {
      //   this.familyEl.textContent = familyName;
      // }

      if (this.descEl) {
        this.descEl.textContent = description;
      }

      // Set disclaimer
      if (this.disclaimerEl) {
        this.disclaimerEl.textContent = window.tdDisclaimer || '';
      }

      // Set detail fields
      if (this.detailsEl) {
        const detailsMap = {
          "composition": content ? this.capitalizeWords(content) : "",
          "rub-count": rubCount ? this.addCommas(rubCount) : "",
          "care": cleaningCode || "",
          "qualities": bestFor ? this.capitalizeWords(bestFor) : "",
          "finish-type": isLeather && finish ? this.capitalizeWords(finish) : ""
        };

        this.detailsEl.querySelectorAll('.td-swatch-drawer-detail').forEach(detailEl => {
          const key = detailEl.getAttribute('data-detail');
          const valueEl = detailEl.querySelector('.td-swatch-drawer-detail-value');

          if (key === 'finish-type') {
            if (isLeather && detailsMap[key]) {
              detailEl.style.display = '';
              if (valueEl) valueEl.textContent = detailsMap[key];
            } else {
              detailEl.style.display = 'none';
              if (valueEl) valueEl.textContent = '';
            }
          } else {
            if (detailsMap[key]) {
              detailEl.style.display = '';
              if (valueEl) valueEl.textContent = detailsMap[key];
            } else {
              detailEl.style.display = 'none';
              if (valueEl) valueEl.textContent = '';
            }
          }
        });
      }

      // Build slides (main + thumbnails) and init swipers
      this.buildCarousel(images, fabricTitle, bestFor);

      // Populate bottom icons
      this.populateBottomIcons(bestFor);

      // Show drawer
      if (this.drawer) this.drawer.classList.add('active');
      if (this.backdrop) this.backdrop.classList.add('active');
      document.documentElement.classList.add('swatch-drawer-visible');
    }

    buildCarousel(images, fabricTitle, bestFor) {
      if (!this.slidesContainerEl || !this.featuredSlidesContainerEl) return;

      this.destroySwipers();
      this.slidesContainerEl.innerHTML = '';
      this.featuredSlidesContainerEl.innerHTML = '';

      // Image slides — one in the main slider, one in the thumbnails
      images.forEach((img, index) => {
        const rawAlt = img.alt || '';
        // Badge text comes from the portion after "|"; absent if no pipe.
        const pipeIndex = rawAlt.indexOf('|');
        const badgeLabel = pipeIndex >= 0 ? rawAlt.slice(pipeIndex + 1).trim() : '';

        const mainSlide = document.createElement('div');
        mainSlide.className = 'swiper-slide td-swatch-featured-slide';
        mainSlide.dataset.colorway = badgeLabel;
        if (badgeLabel) {
          const badge = document.createElement('div');
          badge.className = 'td-swatch-colorway-badge';
          const badgeText = document.createElement('span');
          badgeText.textContent = badgeLabel;
          badge.appendChild(badgeText);
          mainSlide.appendChild(badge);
        }
        const mainImg = document.createElement('img');
        mainImg.className = 'td-swatch-featured-image';
        mainImg.src = img.url;
        mainImg.alt = rawAlt || fabricTitle;
        mainSlide.appendChild(mainImg);
        this.featuredSlidesContainerEl.appendChild(mainSlide);

        const thumbSlide = document.createElement('div');
        thumbSlide.className = 'swiper-slide td-swatch-carousel-slide';
        thumbSlide.dataset.slideIndex = index;
        const thumbImg = document.createElement('img');
        thumbImg.className = 'td-swatch-carousel-img';
        thumbImg.src = img.url;
        thumbImg.alt = rawAlt || fabricTitle;
        thumbSlide.appendChild(thumbImg);
        thumbSlide.addEventListener('click', () => {
          if (!this.mainSwiper) return;
          const actualIndex = Array.from(this.slidesContainerEl.children).indexOf(thumbSlide);
          this.mainSwiper.slideTo(actualIndex);
        });
        this.slidesContainerEl.appendChild(thumbSlide);
      });

      // Features tile — inserted at slot 4 when there are more than 4 image slides; otherwise appended last.
      const matchedFeatures = this.getMatchedFeatures(bestFor);
      if (matchedFeatures.length > 0) {
        const mainFeatureSlide = document.createElement('div');
        mainFeatureSlide.className = 'swiper-slide td-swatch-featured-slide td-swatch-featured-slide--features';
        mainFeatureSlide.dataset.features = 'true';
        mainFeatureSlide.appendChild(this.buildFeaturesTile(matchedFeatures, true));

        const thumbFeatureSlide = document.createElement('div');
        thumbFeatureSlide.className = 'swiper-slide td-swatch-carousel-slide td-swatch-carousel-slide--features';
        thumbFeatureSlide.dataset.slideFeatures = 'true';
        thumbFeatureSlide.appendChild(this.buildFeaturesThumb(matchedFeatures));
        thumbFeatureSlide.addEventListener('click', () => this.goToFeaturesSlide());

        const featuresIndex = 1 //images.length > 4 ? 3 : images.length;
        const mainRef = this.featuredSlidesContainerEl.children[featuresIndex] || null;
        const thumbRef = this.slidesContainerEl.children[featuresIndex] || null;
        this.featuredSlidesContainerEl.insertBefore(mainFeatureSlide, mainRef);
        this.slidesContainerEl.insertBefore(thumbFeatureSlide, thumbRef);
      }

      this.initSwipers();
    }

    buildFeaturesTile(matchedFeatures, isFeatured) {
      const tile = document.createElement('div');
      tile.className = 'td-swatch-features-tile' + (isFeatured ? ' td-swatch-features-tile--featured' : '');

      const badge = document.createElement('div');
      badge.className = 'td-swatch-features-badge';
      badge.textContent = 'Features';
      tile.appendChild(badge);

      const grid = document.createElement('div');
      grid.className = 'td-swatch-features-grid';

      matchedFeatures.forEach(feature => {
        const item = document.createElement('div');
        item.className = 'td-swatch-feature-item';

        const iconWrap = document.createElement('span');
        iconWrap.className = 'td-swatch-feature-icon';
        this.applyFeatureIconMask(iconWrap, feature);

        const title = document.createElement('span');
        title.className = 'td-swatch-feature-title';
        title.textContent = feature.label;

        const desc = document.createElement('span');
        desc.className = 'td-swatch-feature-desc';
        desc.textContent = feature.info;

        item.appendChild(iconWrap);
        item.appendChild(title);
        item.appendChild(desc);
        grid.appendChild(item);
      });

      tile.appendChild(grid);
      return tile;
    }

    buildFeaturesThumb(matchedFeatures) {
      const thumb = document.createElement('div');
      thumb.className = 'td-swatch-features-thumb';

      const label = document.createElement('span');
      label.className = 'td-swatch-features-thumb-label';
      label.textContent = 'Features';
      thumb.appendChild(label);

      const iconsRow = document.createElement('div');
      iconsRow.className = 'td-swatch-features-thumb-icons';
      const maxIcons = 4;
      const visible = matchedFeatures.slice(0, maxIcons);
      visible.forEach(feature => {
        const iconWrap = document.createElement('span');
        iconWrap.className = 'td-swatch-features-thumb-icon';
        this.applyFeatureIconMask(iconWrap, feature);
        iconsRow.appendChild(iconWrap);
      });
      const overflow = matchedFeatures.length - visible.length;
      if (overflow > 0) {
        const more = document.createElement('span');
        more.className = 'td-swatch-features-thumb-more';
        more.textContent = `+${overflow}`;
        iconsRow.appendChild(more);
      }
      thumb.appendChild(iconsRow);

      return thumb;
    }

    applyFeatureIconMask(element, feature) {
      if (!feature || !feature.label) return;
      const key = feature.label.toLowerCase().replace(/\s+/g, '-');
      const icons = window.tdFeatureIcons || {};
      const svg = icons[key];
      if (!svg) return;
      element.classList.add('td-feature-icon-svg');
      element.innerHTML = svg;
      element.setAttribute('role', 'img');
      element.setAttribute('aria-label', feature.label);
    }

    initSwipers() {
      if (!this.carouselEl || !this.featuredSwiperEl) return;

      this.thumbsSwiper = new Swiper(this.carouselEl, {
        slidesPerView: 4,
        spaceBetween: 4,
        watchSlidesProgress: true,
        watchOverflow: true,
        loop: false,
        breakpoints: {
          769: {
            spaceBetween: 5
          }
        },
        on: {
          // `progress` fires on every position change (including touch drags
          // and snap-back transitions), unlike `slideChange` which misses
          // drags that settle on the same slide.
          progress: () => this.updateCaratVisibility(),
          slideChange: () => this.updateCaratVisibility(),
          transitionEnd: () => this.updateCaratVisibility(),
          resize: () => this.updateCaratVisibility(),
          lock: () => this.updateCaratVisibility(),
          unlock: () => this.updateCaratVisibility()
        }
      });

      this.mainSwiper = new Swiper(this.featuredSwiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        autoHeight: true,
        thumbs: { swiper: this.thumbsSwiper }
      });

      // Initial state — both instances are now assigned to `this`.
      this.updateCaratVisibility();
    }

    destroySwipers() {
      if (this.mainSwiper) {
        this.mainSwiper.destroy(true, true);
        this.mainSwiper = null;
      }
      if (this.thumbsSwiper) {
        this.thumbsSwiper.destroy(true, true);
        this.thumbsSwiper = null;
      }
    }

    updateCaratVisibility() {
      if (!this.thumbsSwiper) return;
      // Fractional thumb widths (slidesPerView: 4 + spaceBetween) leave
      // Swiper's isBeginning/isEnd flags stale after touch swipes, so derive
      // edge state from the translate position with a 1px tolerance instead.
      const min = this.thumbsSwiper.minTranslate();
      const max = this.thumbsSwiper.maxTranslate();
      // Thumbs fit entirely → nothing to slide to in either direction.
      const hasOverflow = min - max > 1;
      const atStart = this.thumbsSwiper.translate >= min - 1;
      const atEnd = this.thumbsSwiper.translate <= max + 1;
      if (this.leftCaratEl) {
        this.leftCaratEl.style.display = (hasOverflow && !atStart) ? '' : 'none';
      }
      if (this.rightCaratEl) {
        this.rightCaratEl.style.display = (hasOverflow && !atEnd) ? '' : 'none';
      }
    }

    getMatchedFeatures(bestForString) {
      const normalize = (s) => s.toLowerCase().replace(/\s+/g, '-');
      const bestForTags = (bestForString || '')
        .split(',')
        .map(s => normalize(s.trim()))
        .filter(Boolean);

      const filters = window.tdFeatureFilters || [];
      // Preserve the source "Best For" order so modal matches the swatch page.
      return bestForTags
        .map(tag => filters.find(f => normalize(f.label) === tag))
        .filter(Boolean);
    }

    populateBottomIcons(bestFor) {
      if (!this.iconsBtnEl) return;

      this.iconsBtnEl.innerHTML = '';
      const matchedFeatures = this.getMatchedFeatures(bestFor);

      matchedFeatures.forEach(feature => {
        const iconItem = document.createElement('button');
        iconItem.type = 'button';
        iconItem.className = 'td-material-information__feature-icon';
        iconItem.setAttribute('aria-label', `Show ${feature.label} features`);

        const iconBox = document.createElement('div');
        iconBox.className = 'td-material-information__icon-image';
        this.applyFeatureIconMask(iconBox, feature);

        iconItem.appendChild(iconBox);
        iconItem.addEventListener('click', () => this.goToFeaturesSlide());
        this.iconsBtnEl.appendChild(iconItem);
      });
    }

    goToFeaturesSlide() {
      if (!this.mainSwiper) return;
      const slides = this.mainSwiper.slides;
      for (let i = 0; i < slides.length; i++) {
        if (slides[i].dataset.features === 'true') {
          this.mainSwiper.slideTo(i);
          return;
        }
      }
    }

    addCommas(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    capitalizeWords(sentence) {
      return sentence
        .toLowerCase()
        .replace(/\b\w/g, char => char.toUpperCase());
    }

    closeDrawer() {
      if (this.drawer) this.drawer.classList.remove('active');
      if (this.backdrop) this.backdrop.classList.remove('active');
      document.documentElement.classList.remove('swatch-drawer-visible');
    }

    handleEscape(e) {
      if (e.key === 'Escape' && this.drawer && this.drawer.classList.contains('active')) {
        this.closeDrawer();
      }
    }
  }

  customElements.define('td-material-panel', TdMaterialPanel);
}
